export type WorksheetOption = {
  value: string;
  label: string;
  revealsText?: boolean;
};

export type WorksheetFieldDef<
  TShowWhen,
  TOption extends WorksheetOption = WorksheetOption,
> =
  | {
      kind: "single";
      id: string;
      label: string;
      options: readonly TOption[];
      normal: string | null;
      showWhen?: TShowWhen;
    }
  | {
      kind: "multi";
      id: string;
      label: string;
      options: readonly TOption[];
      showWhen?: TShowWhen;
    }
  | {
      kind: "number";
      id: string;
      label: string;
      unit: string;
      integer?: boolean;
      min?: number;
      max?: number;
      showWhen?: TShowWhen;
    }
  | {
      kind: "text";
      id: string;
      label: string;
      showWhen?: TShowWhen;
    };

export const otherTextKey = (fieldId: string): string => `${fieldId}_other`;
